import React from 'react';
import { Route } from 'react-router-dom';

import PlacementListing from './pages/PlacementListing';

export default () => (
    <Route path="/" component={PlacementListing} />
);
